import { FileDetails, FileShape, FilesApi, FilesRequest } from '@cibo/core'
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { UI_QUERY_KEY } from './queryKey'

export const useFiles = (requestParams?: FilesRequest) => {
  return useQuery<FileShape[]>({
    queryKey: [UI_QUERY_KEY.ALL_FILES, requestParams],
    queryFn: async () => {
      const files = await FilesApi.getFiles(requestParams)
      return files as FileShape[]
    },
  })
}

export const useDeleteFile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (id: string) => FilesApi.deleteFile(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [UI_QUERY_KEY.ALL_FILES] })
    },
  })
}

export const useCreateFile = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (fileDetails: FileDetails) => FilesApi.createFile(fileDetails),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [UI_QUERY_KEY.ALL_FILES] })
    },
  })
}
